import React, { Component } from 'react';
import '../App.css';

//images
import meOnTusk from "../images/me-on-tusk.jpg";

import { Route } from 'react-router-dom';
import App from './App';
import Landing from "./frontpage/landing";
import Photos from './photogram/photos';

class Main extends Component {
  render() {
    return (
      <div className="container">
        <div className="jumbotron">
          <div className="container">
            <div className="left-jumbotron">
              <h1>Will Chantry </h1>
              <div className="contact-links">
                <a href="mailto:will@willchantry.com" className="glyphicon glyphicon-envelope"> will@willchantry.com <br /></a>
                <br />
                  <a href="https://github.com/goofiw" className="glyphicon glyphicon-cloud"> github <br /></a>
                  <br />
                    <a href="https://www.linkedin.com/profile/view?id=207444317&amp;trk=hp-identity-name" className="glyphicon glyphicon-user"> LinkedIn</a>
              </div>
            </div>
            <div className="my-photo">
              <img src={meOnTusk} alt="me on black tusk" className="my-image" />
            </div>
          </div>
        </div>
        <Route exact path="/" component={Landing}></Route>
        <Route path="/photos" component={App(Photos)}></Route>
      </div>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/main.js